import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { classNames } from '../../../utils/helpers';
import { APP_CONFIG } from '../../../utils/constants';
import styles from './Header.module.css';

const Header = ({ tabs = [] }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <nav className={styles.nav}>
          <NavLink to="/" className={styles.logo}>
            <img src="/subwise-logo.svg" alt="Subwise Logo" className={styles.logoIcon} />
            <span className={styles.logoText}>{APP_CONFIG.name}</span>
          </NavLink>

          {/* Desktop Navigation */}
          <div className={styles.desktopTabs}>
            {tabs.map((tab) => (
              <NavLink
                key={tab.id}
                to={tab.path}
                end={tab.path === '/'}
                className={({ isActive }) =>
                  classNames(styles.tab, { [styles.tabActive]: isActive })
                }
              >
                {tab.label}
              </NavLink>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={styles.mobileMenuButton}
            aria-label="Toggle mobile menu"
          >
            {isMobileMenuOpen ? (
              <X className={styles.menuIcon} />
            ) : (
              <Menu className={styles.menuIcon} />
            )}
          </button>
        </nav>

        {/* Mobile Navigation Menu */}
        {isMobileMenuOpen && (
          <div className={styles.mobileMenu}>
            {tabs.map((tab) => (
              <NavLink
                key={tab.id}
                to={tab.path}
                end={tab.path === '/'}
                className={({ isActive }) =>
                  classNames(styles.mobileTab, { [styles.mobileTabActive]: isActive })
                }
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {tab.label}
              </NavLink>
            ))}
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
